import { STATES } from "../../utils/constants";
import { INPUT_TYPES } from "../common/form/GenericForm";

export const general_info = [
  {
    key: "FirstName",
    label: "First Name",
  },
  {
    key: "LastName",
    label: "Last Name",
  },
  {
    key: "Company",
    label: "Company",
  },
  {
    key: "Email",
    label: "Email",
    otherProps: {
      type: "email",
    },
  },
  {
    key: "verifyEmail",
    label: "Verify Email",
    otherProps: {
      type: "email",
    },
  },
];

export const misc_info = [
  {
    key: "OtherCompanies",
    label: "Other Companies",
    comment:
      "Please put down other companies that you are affiliated with that you are requesting association to their parcels, wells, and other information",
  },
  {
    key: "note",
    label: "Note",
    comment:
      "Please enter any notes that may help the NRD identify your farms if under other names or if you are a tennant please tell us the Owner to contact",
  },
];

export const contact_info = [
  {
    key: "Address",
    label: "Address",
  },
  {
    key: "Address2",
    label: "Address Line 2",
  },
  {
    key: "City",
    label: "City",
  },
  {
    key: "State",
    label: "State",
    type: INPUT_TYPES.DROP_DOWN,
    options: STATES,
  },
  {
    key: "ZipCode",
    label: "Zip Code",
  },
  {
    key: "HomePhone",
    label: "Home Phone Number",
    type: INPUT_TYPES.PHONE_NUMBER,
  },

  {
    key: "MobilePhone",
    label: "Mobile Phone Number",
    type: INPUT_TYPES.PHONE_NUMBER,
  },
  {
    key: "BusinessPhone",
    label: "Business Phone Number",
    type: INPUT_TYPES.PHONE_NUMBER,
  },
];

export const districts = [
  "Central Platte NRD",
  "Lewis and Clark NRD",
  "Lower Big Blue NRD",
  "Lower Elkhorn NRD",
  "Lower Loup NRD",
  "Lower Niobrara NRD",
  "Lower Republican NRD",
  "Middle Niobrara NRD",
  "Middle Republican NRD",
  "Nemaha NRD",
  "North Platte NRD",
  "Papio Missouri NRD",
  "South Platte NRD",
  "Tri-Basin NRD",
  "Upper Elkhorn NRD",
  "Upper Loup NRD",
  "Upper Niobrara White NRD",
  "Upper Republican NRD",
];
